import React from "react";
import Lottie from "lottie-react";
import success from "../assets/json/success.json";
import { useNavigate } from "react-router-dom";

const OrderPlaced = ({ message, total }) => {
    const navigate = useNavigate();
    const currentDateTime = new Date();

    const formattedDate = currentDateTime.toLocaleDateString([], {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
    const formattedTime = currentDateTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });

    const cart = async () => {
        window.location.reload();
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div
                className="bg-green-100 border border-green-300 rounded-lg p-6 shadow-lg flex flex-col items-center lg:w-[30%] w-[90%] md:w-[40%] sm:w-[60%]"
                style={{ height: "auto", backgroundColor: "white" }}
            >
                <Lottie loop={false} animationData={success} className="h-24 w-24" />
                <span className="text-2xl font-bold text-[#15803D] mt-4 font-display">Your Order is Placed</span>

                <span className="lg:text-2xl text-xl font-bold text-green-700 mt-4 font-display">{message}</span>
                <span className="lg:text-xl text-xl font-bold text-[#1d1e1d] mt-4 font-display">Continue Shopping</span>

                <div
                    className="mt-6  text-[white] bg-[#8B0000]  font-bold py-3 px-6 rounded-[5px]  font-display cursor-pointer"
                    onClick={cart}
                >
                    Back
                </div>
            </div>
        </div>
    );
};

export default OrderPlaced;
